<template>
  <div class="sobre">
    <banner-interno
    :banner="'bg_topo.jpg'"
    :imagem="sobre.image"
    :titulo="'Sobre nós'"
    />
    <div class="container sobre__info">
      <div class="row">
        <menu-sobre />
        <div class="col-12 col-md-9 sobre__info__dados">
          <div class="row">
            <div class="col-12">
              <h2 class="ui-title-interna ui-title-interna--italic">{{sobre.preview}}</h2>
            </div>
            <div class="col-12 ui-description lh-36" v-html="sobre.description"></div>
          </div>
        </div>
      </div>
    </div>
    <timeline :features="sobre.features"/>
    <div v-if="openMap && pontosMapa.length && sobre.title == 'true'">
      <ContatoMapa
        :enable-infowindow="true"
        :zoom="14"
        css="width:100%;height:100%"
        :points="pontosMapa"
        :latitude="pontosMapa[0].latitude"
        :longitude="pontosMapa[0].longitude"
        :icon="''"
      >
      </ContatoMapa>
    </div>
  </div>
</template>

<script>
import BannerInterno from './BannerInterno'
import Timeline from './Timeline'
import MenuSobre from './MenuSobre'
import ContatoMapa from './ContatoMapa'
import { mapGetters } from 'vuex'
export default {
  components: {
    BannerInterno,
    Timeline,
    MenuSobre,
    ContatoMapa
  },
  data () {
    return {
      openMap: false,
      sobre: '',
      pontos: [],
      pontosMapa: []
    }
  },
  computed: {
    ...mapGetters([
      'page',
      'companyData',
      'empreendimentoEnderecos'
    ])
  },
  created () {
    this.$store.dispatch('showPage', 1)
      .then((result) => {
        this.sobre = result.data
      })
    this.$store.dispatch('showPage', 7)
      .then((result) => {
        let dadosPins = result.data
        this.pontos = JSON.parse(dadosPins.description)
        this.pontos.forEach(element => {
          element.latitude = element.lat
          element.longitude = element.long
          element.title = element.nome
        })
        this.criaPontos()
      })
    this.$store.dispatch('listCompanyData')
  },
  methods: {
    criaPontos () {
      setTimeout(() => {
        this.pontos.forEach(element => {
          if (element.icone === 'comcasa') {
            element.icon = 'static/icon-trim.png'
          } else if (element.icone === 'empreendimento') {
            element.icon = 'static/icon-building.png'
          } else {
            element.icon = 'static/icon-house.png'
          }
          this.pontosMapa.push(element)
        })
      })
      this.openMap = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';

.sobre {
  background: $bgIntern;
  &__info{
    margin-top: 21.5em;
    margin-bottom: 6.5em;
    @media (max-width: 1024px) {
      margin-top: 14em;
      margin-bottom: 4em;
    }
    @media (max-width: 800px) {
      margin-top: 11em;
      margin-bottom: 2em;
    }
    @media (max-width: 500px) {
      margin-top: 6em;
    }
    &__dados{
      p{
        margin-top: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sobre.vue